<template>
    <div id="app">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show">
                    <v-toolbar dark color="blue">
                        <v-toolbar-title>Planilla de Desempeño Proveedor Interno (EI 141)</v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codgral }}
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-toolbar>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="4">
                                <h6 color="black">Proveedor Interno Evaluado: <b>{{ proveedor }}</b></h6>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <h6 color="black">Cliente Interno Evaluador: <b>{{ cliente }}</b></h6>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <h6 color="black">Fecha: <b>{{ fecha }}</b></h6>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <h6 color="black">Período a evaluado: <b>{{ periodo }}</b></h6>
                            </v-col>
                        </v-row>
                        <v-row dense>

                            <v-col cols="6" sm="6" md="3">
                                <h6 color="black">Proceso: <b>{{ proceso }}</b></h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6 color="black">Fecha Evaluación Anterior: <b>{{ fechaulteval }}</b></h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6 color="black">Puntaje Evaluación Anterior: <b>{{ puntajeulteval }}</b></h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6 color="black">Puntaje Presente Evaluación: <b>{{ puntajepreseval }}</b></h6>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-text>
                        <template>
                            <div>
                                <table class="table">
                                    <tr>
                                        <td colspan="6">
                                            <b>Instrucciones:</b> Evalúe cuidadosamente el desempeño en el trabajo
                                            del
                                            proveedor interno, de acuerdo a los requerimientos del cliente interno.
                                            Asigne puntaje de calificación a cada factor evaluado, de acuerdo al
                                            nivel
                                            de escala, e indíquelo en el cuadro de puntuación correspondiente. Se
                                            sumará
                                            el
                                            total de puntos, y se calculará el promedio para una calificación de
                                            desempeño global.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="6" align="center"><b>IDENTIFICACIÓN DE LA CALIFICACIÓN</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="center"><b>Insuficiente</b></td>
                                        <td align="center"><b>Regular</b></td>
                                        <td align="center"><b>Bueno</b></td>
                                        <td align="center"><b>Muy Bueno</b></td>
                                        <td align="center"><b>Excelente</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="center"><b>0 &#8804; n &lt; 3</b></td>
                                        <td align="center"><b>3 &#8804; n &lt; 5</b></td>
                                        <td align="center"><b>5 &#8804; n &lt; 7</b></td>
                                        <td align="center"><b>7 &#8804; n &lt; 9</b></td>
                                        <td align="center"><b>9 &#8804; n &#8804; 10</b></td>
                                    </tr>
                                </table>
                                <table border="2" cellpadding="0" cellspacing="2" width="100%" id="AutoNumber2">
                                    <thead>
                                        <tr>
                                            <td colspan="2" width="65%" align="center"><b>Factores</b></td>
                                            <td width="10%" align="center"><b>Calificación</b></td>
                                            <td width="55%" colspan="2" align="center"><b>Detalle o comentario de
                                                    apoyo</b>
                                            </td>
                                        </tr>
                                        <tr v-for="(tableData, index) in factors" :id="index">
                                            <td width="65%" colspan="2" style="margin: 0">
                                                {{ factors[index].text }}
                                            </td>
                                            <td width="10%" align="center" style="margin: 0">
                                                {{ factors[index].calificacion }}
                                            </td>
                                            <td width="25%" align="center" colspan="2" style="margin: 0">
                                                {{ factors[index].detalle }}</td>
                                        </tr>

                                        <tr>
                                            <td width="65%" colspan="2" style="margin: 0">
                                                Calificación de desempeño global
                                            </td>
                                            <td width="10%" align="center" style="margin: 0">{{ puntajepreseval }}
                                            </td>
                                            <td width="25%" align="center" colspan="2" style="margin: 0"></td>
                                        </tr>


                                    </thead>
                                </table>
                            </div>
                        </template>
                    </v-card-text>
                </v-card>

            </v-form>
        </v-app>
    </div>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<style scoped>
.font-class-name {
    font-size: 14px;
}

.educacion {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
}

.educacion__niveles {
    border: solid 1px;
    list-style: none;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        fecha: moment().format("DD/MM/YYYY"),
        //periodo: "2024",
        proveedor: "",
        cliente: "",
        //codgral: "",
        periodo: moment().subtract(1, "year").year(),
        periodobase: "",
        proceso: "",
        listadoperiodo: [],
        fechaulteval: "",
        puntajepreseval: "",
        puntajeulteval: "",
        calificaciones: [],
        factors: [
            { text: '1. Entrega en término: Información, producto o servicio.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '2. Calidad de la entrega: Información suficiente, servicio eficaz, producto adecuado.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '3. Confiabilidad: Certeza en lo informado, realizado o entregado, que evita demoras.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '4. Calidad de la comunicación:  Respuesta ágil, precisa y eficiente.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '5. Predisposición a la reducción de tiempos / costos: Existencia de no conformidades que originaron perjuicios económicos.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '6. Aceptación de sugerencias: (Modificaciones, agregados que mejoren el desempeño del cliente interno).', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '7. Otras: Describir.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
        ],
        puntajeGlobal: "",
        direccion: "",
        correos: "",
        direcciones: [],
        deshabilitar: false,
    }),
    beforeMount() {

        this.codgral = this.$route.query.codgral;
        this.periodo = this.$route.query.periodo;
        this.cargarDatos();

        return this.visible;

    },
    watch: {
    },
    computed: {

        show: {
            get() {

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargarDatos() {
            let self = this;

            axios
                .get("/RRHH/CargarPlanillaDesempenioProve", {
                    params: {
                        codgral: self.codgral,
                        periodo: self.periodo,
                    },
                })
                .then((response) => {
                    self.periodobase = response.data.periodo;
                    if (response.data.periodo == self.periodo) {
                        self.fechaulteval = response.data.fechaulteval;
                        self.puntajeulteval = response.data.puntajeulteval;
                        self.puntajepreseval = response.data.puntajepreseval;
                    }
                    else {
                        self.fechaulteval = response.data.fecha;
                        self.puntajeulteval = response.data.puntajepreseval;
                        self.puntajepreseval = "";
                    }
                    self.fecha = response.data.fecha;
                    self.proceso = response.data.proceso;
                    self.cliente = response.data.cliente;
                    self.proveedor = response.data.proveedor;
                    self.factors[0].calificacion = response.data.calif1
                    self.factors[1].calificacion = response.data.calif2
                    self.factors[2].calificacion = response.data.calif3
                    self.factors[3].calificacion = response.data.calif4
                    self.factors[4].calificacion = response.data.calif5
                    self.factors[5].calificacion = response.data.calif6
                    self.factors[6].calificacion = response.data.calif7
                    self.factors[0].detalle = response.data.observ1
                    self.factors[1].detalle = response.data.observ2
                    self.factors[2].detalle = response.data.observ3
                    self.factors[3].detalle = response.data.observ4
                    self.factors[4].detalle = response.data.observ5
                    self.factors[5].detalle = response.data.observ6
                    self.factors[6].detalle = response.data.observ7
                    self.puntajeGlobal = response.data.puntajepreseval

                })
                .catch((error) => {

                    console.log(error);
                });
        },


        vaciarListado() {


            this.fecha = "";
            this.periodo = "";
            this.cliente = "";
            this.proveedor = "";
            this.direccion = "";
            this.proceso = "";
            this.factors = [
                { text: '1. Entrega en término: Información, producto o servicio.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '2. Calidad de la entrega: Información suficiente, servicio eficaz, producto adecuado.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '3. Confiabilidad: Certeza en lo informado, realizado o entregado, que evita demoras.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '4. Calidad de la comunicación:  Respuesta ágil, precisa y eficiente.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '5. Predisposición a la reducción de tiempos / costos: Existencia de no conformidades que originaron perjuicios económicos.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '6. Aceptación de sugerencias: (Modificaciones, agregados que mejoren el desempeño del cliente interno).', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '7. Otras: Describir.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            ];
            this.puntajeGlobal = "";
            this.fechaulteval = "";
            this.puntajepreseval = "";
            this.puntajeulteval = "";
            //this.$router.push({ name: "MainRRHH" });
        },


    },
};
</script>